
	export default {
		props: {
			product: {
			type: Object,
			required: false
			}
		},
		data(){
			return {
				items: [],
				isWhiteLabel: false,
				powerdByLink: 'https://truefire.com'
			}
		},
		methods: {
			addItem(label, url){
				this.items.push({label: label, url: url})
			}
		},
		async created() {
			this.configData = await this.$player.getConfig()
			console.log(this.product);
			if(process.client && this.configData){
				this.isWhiteLabel = true;
				this.powerdByLink = this.configData?.marketing?.powered_by_link || 'https://truefire.com'
					if(location.href.includes('/tfs/nuxt')){
					this.backLink = `/tfs/nuxt/partnerships/directory`
				}else{
					this.backLink = `/partnerships/directory`
				}
				if(location.href.includes('partner-nonce')){
					this.backLink += `?partner-nonce=${location.href.substring(location.href.indexOf('=') + 1)}`
				}
				this.addItem('< Back to All Courses', this.backLink)

				this.addItem(this.product.name)
				
			}
			
		}
	}
